import type { ReportViewDefinition, ReportViewFilters } from "@verbleif/lib/src/composables/Api/Type/ReportView/reportView.interface";
import { BUILTIN_REPORT_VIEW_KEYS } from "@web/features/Reports/ReportViewKeys";

export function defaultReportViewFilters(partial: Partial<ReportViewFilters> = {}): ReportViewFilters {
  return {
    statuses: [],
    priorities: [],
    inside: [],
    properties: [],
    propertiesNone: false,
    propertyGroups: [],
    propertyGroupsNone: false,
    sorts: [],
    reportTopics: [],
    createdBy: "any",
    transferred: "any",
    createdAt: null,
    updatedAt: null,
    pinned: "any",
    ...partial,
  };
}

export function defaultReportViewDefinition(partial: Omit<Partial<ReportViewDefinition>, "filters"> & { filters?: Partial<ReportViewFilters> } = {}): ReportViewDefinition {
  const { filters, ...rest } = partial;
  return {
    filters: defaultReportViewFilters(filters),
    requiredScope: null,
    ...rest,
  };
}

export const BUILTIN_REPORT_VIEW_DEFINITIONS: Record<string, ReportViewDefinition> = {
  [BUILTIN_REPORT_VIEW_KEYS.ALL]: defaultReportViewDefinition(),
  [BUILTIN_REPORT_VIEW_KEYS.PINNED]: defaultReportViewDefinition({
    filters: { pinned: "only" },
  }),
  [BUILTIN_REPORT_VIEW_KEYS.OPEN]: defaultReportViewDefinition({
    filters: { statuses: [0] },
  }),
  [BUILTIN_REPORT_VIEW_KEYS.CLOSED]: defaultReportViewDefinition({
    filters: { statuses: [1] },
  }),
  [BUILTIN_REPORT_VIEW_KEYS.CREATED_BY_ME]: defaultReportViewDefinition({
    filters: { createdBy: "me" },
  }),
  [BUILTIN_REPORT_VIEW_KEYS.GUEST]: defaultReportViewDefinition({
    filters: { createdBy: "guest" },
  }),
  [BUILTIN_REPORT_VIEW_KEYS.TRANSFERRED]: defaultReportViewDefinition({
    filters: { transferred: "only" },
  }),
};
